export default __webpack_public_path__ + "static/media/imagem_para_tela_inicial.3f7c9a2f.png";